import styled from "@emotion/styled/macro";
import CardView from "../Cards/CardView";
import { ContentLayout } from "../../ui/ContentLayout";
const CardWrapper = styled.div`
  position: relative;
  padding-bottom: 5em;
`;
const BlueBackground = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 75%;
    z-index: 0;
  }
  height: 101%;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.aero};
`;

const CardPart = ({ cards }) => {
  return (
    <CardWrapper>
      <ContentLayout>
        <CardView cards={cards} />
      </ContentLayout>
      <BlueBackground />
    </CardWrapper>
  );
};

export default CardPart;
